namespace $ {

	export function $shm_projects_order< Project extends { id: string } >( projects: readonly Project[] ): Project[] {
		const priority = [ 'shared-modules', 'hitalama', 'projects', 'monitoring-plus', 'monitoring-plus-clean' ]
		const rank = ( id: string )=> {
			const index = priority.indexOf( id )
			return index < 0 ? priority.length : index
		}
		return projects.toSorted( ( left, right )=> rank( left.id ) - rank( right.id ) )
	}

}
